import React from 'react';

const gpsre = /^\d+(\.\d+)?, \d+(\.\d+)?$/;
const re = /^(.*?)( ?(buss|statio|,|\(|hållplats).+)$/;

const StationName = (props: { name: string; }) => {
	const { name } = props;
	if (name.match(gpsre)) {
		return <a
			href={"https://maps.google.com/maps?q=loc:" + name}
			target={"_blank"}
			rel="noreferrer"
		>
			Min plats
		</a>
	}
	const found = name.match(re);
	if (found) {
		return (
			<>
				<b>{found[1]}</b>
			</>
		);

	}
	return <>{name}</>;
};


export default StationName;